<div class="wrapper-content game-wrapper-full color-1" [style.background]="'url('+'/assets/games/fuego-04.jpg'+')' ">
  <div class="game-header fullwidth">
    <h5 class="legend">Educación Ambiental</h5>
    <h1 class="title">INGRESO</h1>
    <a class="btn-back" (click)="route.goBack()" style="text-decoration: none;">
      <svg xmlns="http://www.w3.org/2000/svg" width="85" height="85" viewBox="0 0 85 85">
        <g id="Grupo_75" data-name="Grupo 75" transform="translate(-1142 -30)">
          <rect id="Rectángulo_145" data-name="Rectángulo 145" width="85" height="85" transform="translate(1142 30)" />
          <g id="Grupo_73" data-name="Grupo 73" transform="translate(1164.95 52.95)">
            <rect id="Rectángulo_3" data-name="Rectángulo 3" width="51" height="5.1"
              transform="translate(0 36.062) rotate(-45)" fill="#fff" />
            <rect id="Rectángulo_141" data-name="Rectángulo 141" width="51" height="5.1"
              transform="translate(3.606 0) rotate(45)" fill="#fff" />
          </g>
        </g>
      </svg>
    </a>
  </div>

  <a  (click)="route.goBack()" class="btn-back-2"
    style="z-index: 3">
    <svg xmlns="http://www.w3.org/2000/svg" width="85" height="85" viewBox="0 0 85 85">
      <g id="Grupo_87" data-name="Grupo 87" transform="translate(-1142 -30)">
        <rect id="Rectángulo_145" data-name="Rectángulo 145" width="85" height="85" transform="translate(1142 30)" />
        <path id="Trazado_35" data-name="Trazado 35" d="M2420,308.187l21.85,21.85,21.85-21.85"
          transform="translate(1503.537 -2369.5) rotate(90)" fill="none" stroke="#fff" stroke-width="7" />
      </g>
    </svg>
  </a>

  <div class="game-content transparent" style="width:100%">

    <div class="container-fluid" *ngIf="user.isLogued()==true && user.profile">
      <div class="app-card-row-full column">
        <div class="col-12">
          <h2 class="text-center" style="color: white">Bienvenido {{user.profile.firstname}}!!</h2>
        </div>
        <div class="col-12"  style="margin-top: 20px;display: flex;
        justify-content: center;">
          <a class="btn-theme ts-background-4" (click)="route.goTo('juego-inicio/incendios')">Continuar</a>
        </div>
      </div>
    </div>

    <div class="container-fluid" *ngIf="!user.isLogued() && view =='mail_sent'">

      <div class="app-card-row-full column">
        <div class="col-12">
          <h2 class="text-center" style="color: white">Gracias por registrarte!!</h2>
        </div>
        <div class="col-12" style="margin-top: 20px;display: flex;
        justify-content: center;">
          <a class="btn-theme ts-background-4" (click)="view='login'">Íniciar sesión</a>
        </div>

      </div>
    </div>

    <div class="container-fluid" *ngIf="!user.isLogued() && view =='login'">
      <form #form="ngForm" (ngSubmit)="callLogin(form)">
        <div class="row column">
          <div class="col-12">
            <h2 class="text-center" style="color: white">Ingresa tus datos</h2>
          </div>
          <div class="col-12">
            <span class="input input--chisato centered" style="min-width: 100%;">
              <input name="email" #email="ngModel" [(ngModel)]="formdata.email"
                class="input__field input__field--chisato" type="text" id="input-7" />
              <label class="input__label input__label--chisato" for="input-7">
                <span class="input__label-content input__label-content--chisato"
                  data-content="Correo electrónico">{{formdata.email?formdata.email:'Correo electrónico'}}</span>
              </label>

            </span>
            <span class="input input--chisato centered" style="min-width: 100%;">
              <input name="password" #password="ngModel" [(ngModel)]="formdata.password" type="password"
                class="input__field input__field--chisato" type="text" id="input-7" />
              <label class="input__label input__label--chisato" for="input-7">
                <span class="input__label-content input__label-content--chisato"
                  data-content="Contraseña">{{formdata.password?formdata.password:'Contraseña'}}</span>
              </label>

            </span>
          </div>
          <div class="col-12">
            <a style="padding:0 15px;color: white; text-decoration: underline;">Olvide mi contraseña</a>
          </div>
          <div class="col-12 button-box" >
            <button style="margin: 10px" type="submit" class="btn-theme ts-background-4" (click)="callLogin(form)">Íniciar sesión</button>
            <button style="margin: 10px" class="btn-theme ts-background-4" (click)="view='register'">registrarme</button>
          </div>
        </div>
      </form>
    </div>

    <div class="container-fluid" *ngIf="!user.isLogued() && view =='register'">
      <form #form2="ngForm" (ngSubmit)="register()">
        <div class="row column">
          <div class="col-12">
            <h2 class="text-center" style="color: white">Registrate</h2>
          </div>
          <div class="col-12">
            <span class="input input--chisato centered" style="min-width: 100%;padding-bottom: 0;">
              <input name="firstname"  #firstname="ngModel" [(ngModel)]="formdata2.firstname" class="input__field input__field--chisato"
                type="text" id="input-7" />
              <label class="input__label input__label--chisato" for="input-7">
                <span class="input__label-content input__label-content--chisato"
                  data-content="Nombre">{{formdata2.firstname?formdata2.firstname:'Nombre'}}</span>
              </label>

            </span>
            <span class="input input--chisato centered" style="min-width: 100%;padding-bottom: 0;">
              <input name="email"  #email="ngModel" [(ngModel)]="formdata2.email" class="input__field input__field--chisato" type="text"
                id="input-7" />
              <label class="input__label input__label--chisato" for="input-7">
                <span class="input__label-content input__label-content--chisato"
                  data-content="Correo electrónico">{{formdata2.email?formdata2.email:'Correo electrónico'}}</span>
              </label>

            </span>
            <span class="input input--chisato centered" style="min-width: 100%;padding-bottom: 0;">
              <input name="password"  #password="ngModel" [(ngModel)]="formdata2.password" type="password"
                class="input__field input__field--chisato" type="text" id="input-7" />
              <label class="input__label input__label--chisato" for="input-7">
                <span class="input__label-content input__label-content--chisato"
                  data-content="Contraseña">{{formdata2.password?formdata2.password:'Contraseña'}}</span>
              </label>

            </span>
            <span class="input input--chisato centered" style="min-width: 100%;padding-bottom: 0;">
              <input name="phone"  #phone="ngModel" [(ngModel)]="formdata2.phone" class="input__field input__field--chisato" type="text"
                id="input-7" />
              <label class="input__label input__label--chisato" for="input-7">
                <span class="input__label-content input__label-content--chisato"
                  data-content="Celular">{{formdata.phone?formdata.phone:'Celular'}}</span>
              </label>

            </span>
          </div>

          <div class="col-12">
            <a style="padding:0 15px;color: white;">Olvide mi contraseña</a>
          </div>
          <div class="col-12 button-box">
            <button style="margin: 10px" type="submit" class="btn-theme ts-background-4" (click)="register()">Crear cuenta</button>
            <button style="margin: 10px" class="btn-theme ts-background-4"(click)="view='login'">Íniciar sesión</button>
          </div>

        </div>
      </form>
    </div>

  </div>



</div>
